export const COLLECTION_TYPES = {
    maps: 'maps',
    players: 'players',
    characters: 'characters',
    tokens: 'tokens',
    permissions: 'permissions',
    templates: 'templates',
    guides: 'guides',
    initiative: 'initiative',
} as const;

export type CollectionType = (typeof COLLECTION_TYPES)[keyof typeof COLLECTION_TYPES];
